<template>
  <div :id="componentId" class="sp3-module-1" :style="moduleStyle">
    <div class="sp3-banner-wrap">
      <img
        v-if="bannerUrl"
        class="sp3-banner-image"
        referrerpolicy="no-referrer"
        :src="bannerUrl"
      >
      <div v-else class="sp3-banner-placeholder">请配置大图</div>
    </div>

    <div class="sp3-content" :style="contentStyle">
      <div class="sp3-content-inner">
        <div class="sp3-right-section">
          <div class="sp3-right-header">
            <span class="sp3-right-title-text">{{ rightTitle || '全国两会' }}</span>
          </div>
          <div class="sp3-right-card">
            <div class="sp3-right-list">
              <div
                v-for="(item, index) in displayRightList"
                :key="index"
                class="sp3-right-item"
                @click="goTo(item.url)"
              >
                <div class="sp3-right-date">
                  <span class="sp3-right-day">{{ item.day || '09' }}</span>
                  <span class="sp3-right-month">{{ item.month || '2026-06' }}</span>
                </div>
                <div class="sp3-right-divider" />
                <div class="sp3-right-item-title">{{ item.title || '标题' }}</div>
              </div>
            </div>
          </div>
          <div class="sp3-right-bottom-bar" />
        </div>

        <div class="sp3-left-section">
          <div class="sp3-left-title">{{ leftTitle || '聚焦两会' }}</div>
          <div class="sp3-focus-list">
            <div
              v-for="(item, index) in displayLeftList"
              :key="index"
              class="sp3-focus-item"
            >
              <div class="sp3-focus-image-wrap" @click="goTo(item.url)">
                <img
                  v-if="item.imageUrl"
                  class="sp3-focus-image"
                  referrerpolicy="no-referrer"
                  :src="item.imageUrl"
                >
                <div v-else class="sp3-focus-image-placeholder">图片</div>
              </div>
              <div class="sp3-focus-main-title" @click="goTo(item.url)">{{ item.title || '标题' }}</div>
              <div class="sp3-focus-sub-list">
                <div
                  v-for="(sub, subIndex) in item.subList"
                  :key="subIndex"
                  class="sp3-focus-sub-row"
                >
                  <div class="sp3-focus-sub-item" @click="goTo(sub.url)">
                    {{ sub.title || '子标题' }}
                  </div>
                  <div v-if="subIndex < item.subList.length - 1" class="sp3-focus-sub-divider" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_LEFT_ITEM = {
  imageUrl: '',
  title: '第七届中国品牌发展论坛系列活动现',
  newsCode: '',
  url: '',
  subList: [
    { title: '必须深刻把握中国式现代化对教育', newsCode: '', url: '' },
    { title: '必须深刻把握中国式现代化对教育', newsCode: '', url: '' },
    { title: '必须深刻把握中国式现代化对教育', newsCode: '', url: '' }
  ]
}

const DEFAULT_RIGHT_ITEM = {
  day: '09',
  month: '2026-06',
  title: '第七届中国品牌发展论坛系列活动现场花絮!',
  newsCode: '',
  url: ''
}

export default {
  name: 'SpThreeModule1',
  props: {
    componentId: {
      type: String,
      default: 'sp_three_module_1'
    }
  },
  data() {
    return {
      bannerUrl: '',
      bgColor: '#FFF5F0',
      leftTitle: '聚焦两会',
      rightTitle: '全国两会',
      rightList: Array.from({ length: 6 }, () => ({ ...DEFAULT_RIGHT_ITEM })),
      leftList: [
        { ...DEFAULT_LEFT_ITEM },
        { ...DEFAULT_LEFT_ITEM }
      ]
    }
  },
  computed: {
    displayRightLists() {
      return (this.rightList || []).slice(0, 6)
    },
    displayRightList() {
      return (this.rightList || []).slice(0, 6)
    },
    displayLeftList() {
      const list = (this.leftList || []).slice(0, 2).map(item => ({
        ...item,
        subList: (item.subList || []).slice(0, 3)
      }))
      if (list.length < 2) {
        while (list.length < 2) {
          list.push({ ...DEFAULT_LEFT_ITEM })
        }
      }
      return list
    },
    moduleStyle() {
      return {
        backgroundColor: this.bgColor
      }
    },
    contentStyle() {
      return {
        backgroundColor: this.bgColor
      }
    }
  },
  methods: {
    goTo(url) {
      if (!url) return
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.sp3-module-1 {
  position: relative;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp3-banner-wrap {
  position: relative;
  width: 100%;
  height: 52vw;
  min-height: 180px;
  max-height: 390px;
  overflow: hidden;
  background: #E0E0E0;
}

.sp3-banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp3-banner-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp3-content {
  position: relative;
  width: 100%;
  padding-bottom: 24px;
}

.sp3-content-inner {
  display: flex;
  flex-direction: column;
  width: calc(100% - 24px);
  margin: 0 auto;
  padding-top: 16px;
  gap: 20px;
}

.sp3-right-section {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sp3-right-header {
  display: flex;
  align-items: center;
  height: 48px;
  background: linear-gradient(90deg, #CB2F30 0%, #E96E74 100%);
  border-radius: 8px 8px 0 0;
  padding-left: 16px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.sp3-right-title-text {
  font-size: 18px;
  color: #FFFFFF;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sp3-right-card {
  flex: 1;
  width: 100%;
  background: #F9F9F9;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sp3-right-list {
  flex: 1;
  overflow: hidden;
}

.sp3-right-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 56px;
  padding: 8px 12px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sp3-right-item:hover {
  background: linear-gradient(90deg, #F1E2DF 0%, #E3B7B3 100%);
}

.sp3-right-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 46px;
  flex-shrink: 0;
}

.sp3-right-day {
  font-size: 16px;
  color: #000000;
  line-height: 1.2;
  text-align: center;
}

.sp3-right-month {
  font-size: 10px;
  color: #000000;
  line-height: 1.4;
  text-align: center;
}

.sp3-right-divider {
  width: 2px;
  height: 32px;
  margin: 0 12px;
  border-radius: 0;
  background: linear-gradient(228deg, rgba(197, 116, 111, 1), rgba(236, 186, 181, 1));
  mask-image: repeating-linear-gradient(to bottom, #000 0, #000 4px, transparent 4px, transparent 8px);
  -webkit-mask-image: repeating-linear-gradient(to bottom, #000 0, #000 4px, transparent 4px, transparent 8px);
  flex-shrink: 0;
}

.sp3-right-item-title {
  flex: 1;
  font-size: 13px;
  color: #000000;
  line-height: 1.5;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.sp3-right-bottom-bar {
  width: 100%;
  height: 6px;
  background: linear-gradient(90deg, #BF1607 0%, #9C3535 100%);
  border-radius: 0 0 8px 8px;
  flex-shrink: 0;
}

.sp3-left-section {
  width: 100%;
}

.sp3-left-title {
  font-size: 20px;
  text-align: center;
  line-height: 1.4;
  background: linear-gradient(90deg, #FB2911 0%, #930000 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sp3-focus-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 16px;
}

.sp3-focus-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.sp3-focus-image-wrap {
  width: 100%;
  height: 24vw;
  min-height: 100px;
  overflow: hidden;
  background: #E0E0E0;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.sp3-focus-image-wrap:hover {
  opacity: 0.85;
}

.sp3-focus-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp3-focus-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp3-focus-main-title {
  width: 100%;
  margin-top: 10px;
  font-size: 13px;
  color: #000000;
  line-height: 1.5;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
  transition: color 0.2s ease;
}

.sp3-focus-main-title:hover {
  color: #CB2F30;
}

.sp3-focus-sub-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 12px;
}

.sp3-focus-sub-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.sp3-focus-sub-item {
  width: 100%;
  padding: 10px 0;
  font-size: 13px;
  color: #000000;
  line-height: 1.5;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.sp3-focus-sub-item:hover {
  color: #CB2F30;
}

.sp3-focus-sub-divider {
  width: 100%;
  height: 1px;
  border: none;
  border-bottom: 1px dashed #D8D8D8;
  box-sizing: border-box;
}
</style>
